__turbopack_context__.v({
  "app": "pGNjjG_app",
  "bottom": "pGNjjG_bottom",
  "content": "pGNjjG_content",
  "footer": "pGNjjG_footer",
  "link": "pGNjjG_link",
  "link-container": "pGNjjG_link-container",
  "links": "pGNjjG_links",
  "logo": "pGNjjG_logo",
  "shimmer": "pGNjjG_shimmer",
  "social": "pGNjjG_social",
  "stores": "pGNjjG_stores",
  "text-bar-sweep": "pGNjjG_text-bar-sweep",
});
